module.exports = __webpack_public_path__ + "img/guest-logo-active.6cb23242.svg";